const spacing = {
  0: '0px',
  1: '1px',
  2: '2px',
  5: '8px',
  7: '12px',
  10: '16px',
  13: '20px',
  15: '24px',
  20: '32px',
  25: '40px',
  30: '48px',
  40: '64px',
  45: '72px',
  50: '80px',
  60: '96px',
  70: '112px',
  80: '128px',
} as const

export default spacing
